import { ObjectType, Field, Float } from 'type-graphql'
import { prop as Prop, modelOptions } from '@typegoose/typegoose'
import { BaseEntity, Customer, RelatedEntity } from '@ztechapps/common.contract'
import { InvoiceItem } from './InvoiceItem'
import { InvoicePayment } from './InvoicePayment'

@ObjectType()
@modelOptions({
  schemaOptions: {
    timestamps: true,
    collection: 'invoices', // Set your desired collection name here
  },
})
export class Invoice extends BaseEntity {
  @Field(() => Customer)
  @Prop({ type: RelatedEntity })
  billTo: Customer

  @Field(() => Date)
  @Prop({ type: Date })
  date: Date

  @Field(() => Date)
  @Prop({ type: Date })
  dueDate: Date

  @Field(() => Date)
  @Prop({ type: Date })
  shipDate: Date

  @Field(() => String)
  @Prop({ type: String })
  poNumber: string

  @Field(() => Float)
  @Prop({ type: Number })
  grossAmount: number

  @Field(() => Float)
  @Prop({ type: Number })
  discountAmount: number

  @Field(() => Float)
  @Prop({ type: Number })
  netAmount: number

  @Field(() => [InvoiceItem])
  @Prop({ type: () => [InvoiceItem] })
  items: InvoiceItem[]

  @Field(() => InvoicePayment)
  @Prop({ type: InvoicePayment })
  payment: InvoicePayment

  @Field(() => String)
  @Prop({ type: String })
  dueNotice: string

  @Field(() => String)
  @Prop({ type: String })
  url: string

  @Field(() => String)
  @Prop({ type: String })
  freshbooksId: string

  @Field(() => String)
  @Prop({ type: String })
  freshbooksUrl: string

  @Field(() => String)
  @Prop({ type: String })
  issueDateYearMonth: string

  @Field(() => String)
  @Prop({ type: String })
  timeZone: string

  @Field(() => String)
  @Prop({ type: String })
  quickbooksId: string
}
